"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestERC1155__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
        ],
        name: "TransferBatch",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "TransferSingle",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "value",
                type: "string",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "URI",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "owners",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
        ],
        name: "balanceOfBatch",
        outputs: [
            {
                internalType: "uint256[]",
                name: "balances",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "safeBatchTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "uri",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class TestERC1155__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.TestERC1155__factory = TestERC1155__factory;
TestERC1155__factory.bytecode = _bytecode;
TestERC1155__factory.abi = _abi;
//# sourceMappingURL=TestERC1155__factory.js.map